export const titleText = "You are not Registered";
export const subtitleText = 'Wait your turn to enter the Temple and sacrifice a qualified NFT';
export const ctaOneText = 'Back';
